import {
  GET_CALL_SUMMARY,
  GET_CALL_SUMMARY_SUCCESS,
  GET_CALL_SUMMARY_ERROR,
} from "./actionTypes"

export const getCallSummary = (payload) => {
  return {
    type: GET_CALL_SUMMARY,
    payload: payload
  }
}

export const getCallSummarySuccess = (summary) => ({
  type: GET_CALL_SUMMARY_SUCCESS,
  payload: summary
})

export const getCallSummaryError = (error) => ({
  type: GET_CALL_SUMMARY_ERROR,
  payload: error
})
